export default {

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/statistics/getters.js